var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTerm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0a1 1 0 00-.984 1.02v7c0 1.33.527 2.6 1.46 3.54a5.001 5.001 0 003.54 1.46h9.58l-3.29 3.29a1 1 0 101.41 1.42l4.91-4.91a1 1 0 00.004-1.59l-4.92-4.92a1 1 0 00-.717-.303 1 1 0 00-.697 1.72l3.29 3.29h-9.59a2.99 2.99 0 01-2.12-.879 3.006 3.006 0 01-.88-2.12v-7a1 1 0 00-1.02-1.02z"
  })));
}

export default SvgTerm;